(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tpb-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('tpb-collection-tabs')) return;

    class TpbCollectionTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-ctabs-tab]'));
        this.panels = Array.prototype.slice.call(this.querySelectorAll('[data-ctabs-panel]'));
        var self = this;
        this.tabs.forEach(function (tab, i) {
          tab.addEventListener('click', function () { self.select(i, false); });
          tab.addEventListener('keydown', function (e) {
            if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
            e.preventDefault();
            var next = (i + (e.key === 'ArrowRight' ? 1 : -1) + self.tabs.length) % self.tabs.length;
            self.select(next, true);
          });
        });
      }

      select(index, focus) {
        this.tabs.forEach(function (tab, i) {
          var on = i === index;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
        });
        this.panels.forEach(function (panel, i) {
          panel.hidden = i !== index;
          if (i === index) {
            var track = panel.querySelector('[data-ctabs-track]');
            if (track) track.scrollLeft = 0;
          }
        });
        if (focus && this.tabs[index]) this.tabs[index].focus();
      }
    }

    customElements.define('tpb-collection-tabs', TpbCollectionTabs);

    // Éditeur de thème : sélectionner un bloc « onglet » l'affiche.
    document.addEventListener('shopify:block:select', function (e) {
      var tab = e.target.closest && e.target.closest('[data-ctabs-tab]');
      var wrap = tab && tab.closest('tpb-collection-tabs');
      if (wrap) wrap.select(wrap.tabs.indexOf(tab), false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpb-feed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('tpb-feed-video')) return;
    class TpbFeedVideo extends HTMLElement {
      connectedCallback() {
        var self = this;
        var btn = this.querySelector('[data-feed-play]');
        if (!btn) return;
        btn.addEventListener('click', function () { self.play(); });
      }
      play() {
        var tpl = this.querySelector('template[data-feed-template]');
        var video = this.querySelector('video');
        if (!video && tpl) {
          this.appendChild(tpl.content.cloneNode(true));
          video = this.querySelector('video');
        }
        if (!video) return;
        this.classList.add('is-playing');
        // Met en pause les autres vidéos du mur
        document.querySelectorAll('tpb-feed-video.is-playing video').forEach(function (v) {
          if (v !== video) v.pause();
        });
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
        video.focus({ preventScroll: true });
      }
    }
    customElements.define('tpb-feed-video', TpbFeedVideo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpb-main-cart"]) return;
  try {
    
  (function () {
    if (customElements.get('tpb-cart-page')) return;

    class TpbCartPage extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.addEventListener('click', function (e) {
          var qtyBtn = e.target.closest('[data-cart-qty]');
          var rm = e.target.closest('[data-cart-remove]');
          var btn = qtyBtn || rm;
          if (!btn || !window.TPB || !window.TPB.cart) return;
          e.preventDefault();
          self.update(btn, btn.getAttribute('data-key'), qtyBtn ? Number(qtyBtn.getAttribute('data-cart-qty')) : 0);
        });
        this.addEventListener('change', function (e) {
          var input = e.target.closest('[data-cart-input]');
          if (input && window.TPB && window.TPB.cart) {
            self.update(input, input.getAttribute('data-key'), Math.max(0, parseInt(input.value, 10) || 0));
            return;
          }
          var note = e.target.closest('[data-cart-note]');
          if (note) {
            fetch((window.TPB_CONFIG && window.TPB_CONFIG.routes.cartUpdate || '/cart/update') + '.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ note: note.value })
            });
          }
        });
      }
      update(el, key, qty) {
        var line = el.closest('[data-cart-line]');
        if (line) line.classList.add('is-updating');
        window.TPB.cart.change(key, qty).catch(function (err) {
          if (line) line.classList.remove('is-updating');
          if (window.TPB.showError) window.TPB.showError(err.message, el);
        });
      }
    }

    customElements.define('tpb-cart-page', TpbCartPage);

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpb-pack-compare"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('tpb-pack-compare')) return;
    class TpbPackCompare extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.track = this.querySelector('[data-pcmp-track]');
        this.bar = this.querySelector('[data-pcmp-bar]');
        this.thumb = this.querySelector('[data-pcmp-thumb]');
        if (!this.track) return;
        this.querySelectorAll('[data-pcmp-prev]').forEach(function (b) {
          b.addEventListener('click', function () { self.step(-1); });
        });
        this.querySelectorAll('[data-pcmp-next]').forEach(function (b) {
          b.addEventListener('click', function () { self.step(1); });
        });
        this._onScroll = function () { self.update(); };
        this.track.addEventListener('scroll', this._onScroll, { passive: true });
        if ('ResizeObserver' in window) {
          this._ro = new ResizeObserver(function () { self.update(); });
          this._ro.observe(this.track);
        }
        this.update();
      }
      disconnectedCallback() {
        if (this._ro) this._ro.disconnect();
      }
      colWidth() {
        var head = this.track.querySelector('.tpb-pcmp__head');
        return head ? head.getBoundingClientRect().width : 150;
      }
      step(dir) {
        this.track.scrollBy({ left: dir * this.colWidth(), behavior: 'smooth' });
      }
      update() {
        if (!this.bar || !this.thumb) return;
        var max = this.track.scrollWidth - this.track.clientWidth;
        this.bar.hidden = max <= 1;
        var p = max > 0 ? this.track.scrollLeft / max : 0;
        this.thumb.style.left = (Math.min(1, Math.max(0, p)) * 60).toFixed(2) + '%';
      }
    }
    customElements.define('tpb-pack-compare', TpbPackCompare);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpb-pack-steps"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__tpbPackStepsVideo) return;
    window.__tpbPackStepsVideo = true;

    function play(video) {
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }

    // Lecture automatique en boucle ; les vidéos hors écran sont mises en pause (performances)
    // et reprennent quand elles redeviennent visibles, sauf si la cliente les a mises en pause.
    function init(root) {
      var videos = (root || document).querySelectorAll('video.tpb-psteps__video');
      videos.forEach(function (video) {
        if (video.dataset.tpbInit) return;
        video.dataset.tpbInit = '1';
        video.muted = true;
        video.loop = true;
        video.setAttribute('playsinline', '');
        video.addEventListener('play', function () { video.parentElement.classList.add('is-playing'); });
        video.addEventListener('pause', function () { video.parentElement.classList.remove('is-playing'); });
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                if (!video.dataset.userPaused) play(video);
              } else if (!video.paused) {
                video.pause();
              }
            });
          }, { threshold: 0.15 }).observe(video);
        } else {
          play(video);
        }
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pack-step-play]');
      if (!btn) return;
      var video = btn.parentElement && btn.parentElement.querySelector('video');
      if (!video) return;
      if (video.paused) {
        delete video.dataset.userPaused;
        play(video);
      } else {
        video.dataset.userPaused = '1';
        video.pause();
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    // Éditeur de thème : la section est re-rendue à chaque modification
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpb-quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('tpb-quiz')) return;

    function money(cents) {
      if (window.TPB && typeof window.TPB.money === 'function') return window.TPB.money(cents);
      return (Number(cents || 0) / 100).toFixed(2).replace('.', ',') + ' €';
    }

    function pairs(lines) {
      var out = {};
      (lines || []).forEach(function (line) {
        var parts = String(line).split('|');
        if (parts.length < 2) return;
        var key = parts[0].trim();
        if (key) out[key] = parts.slice(1).join('|').trim();
      });
      return out;
    }

    function el(tag, className, text) {
      var node = document.createElement(tag);
      if (className) node.className = className;
      if (text != null) node.textContent = text;
      return node;
    }

    class TpbQuiz extends HTMLElement {
      connectedCallback() {
        var self = this;
        try {
          this.config = JSON.parse(this.querySelector('[data-quiz-config]').textContent);
        } catch (e) {
          this.config = { routines: [], strings: {} };
        }
        this.durations = pairs(this.config.durations);
        this.rules = pairs(this.config.rules);
        this.steps = Array.prototype.slice.call(this.querySelectorAll('[data-quiz-step]'));
        this.result = this.querySelector('[data-quiz-result]');
        this.answers = [];
        this.step = 0;

        this.addEventListener('click', function (e) {
          var option = e.target.closest('[data-quiz-option]');
          if (option) { self.choose(option); return; }
          if (e.target.closest('[data-quiz-back]')) { self.show(Math.max(0, self.step - 1)); return; }
          if (e.target.closest('[data-quiz-restart]')) { self.restart(); }
        });

        this._onBlockSelect = function (e) {
          if (!self.contains(e.target)) return;
          var stepEl = e.target.closest('[data-quiz-step]');
          if (stepEl) { self.show(Number(stepEl.getAttribute('data-quiz-step'))); return; }
          var marker = e.target.closest('[data-routine-marker]');
          if (marker) {
            self.answers = [{ value: marker.getAttribute('data-routine-marker'), label: '' }];
            self.renderResult();
          }
        };
        document.addEventListener('shopify:block:select', this._onBlockSelect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this._onBlockSelect);
      }

      show(index) {
        this.step = index;
        this.steps.forEach(function (s, i) { s.hidden = i !== index; });
        if (this.result) this.result.hidden = true;
        var current = this.steps[index];
        var answer = this.answers[index];
        if (current) {
          current.querySelectorAll('[data-quiz-option]').forEach(function (o) {
            o.classList.toggle('is-selected', !!answer && o.getAttribute('data-value') === answer.value);
          });
        }
      }

      choose(option) {
        this.answers[this.step] = { value: option.getAttribute('data-value'), label: option.getAttribute('data-label') };
        option.classList.add('is-selected');
        if (this.step >= this.steps.length - 1) {
          this.renderResult();
          var top = this.getBoundingClientRect().top + window.scrollY - 120;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        } else {
          this.show(this.step + 1);
        }
      }

      restart() {
        this.answers = [];
        this.show(0);
        var top = this.getBoundingClientRect().top + window.scrollY - 120;
        if (window.scrollY > top) window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }

      routineFor(value) {
        var list = this.config.routines || [];
        for (var i = 0; i < list.length; i++) if (list[i].value === value) return list[i];
        return list[0] || null;
      }

      renderResult() {
        var cfg = this.config;
        var str = cfg.strings || {};
        var first = this.answers[0];
        var routine = this.routineFor(first ? first.value : '');
        this.steps.forEach(function (s) { s.hidden = true; });
        if (!this.result || !routine) return;
        this.result.hidden = false;

        // Cure : règle liée à la réponse à la dernière question, sinon cure de la routine
        var pos = Number(routine.pos) || 1;
        var last = this.answers[this.steps.length - 1];
        if (last && this.rules[last.value]) pos = Number(this.rules[last.value]) || pos;

        var items = [];
        var base = routine.base;
        if (base && base.variants && base.variants.length) {
          var idx = Math.min(Math.max(pos, 1), base.variants.length) - 1;
          var variant = base.variants[idx];
          var duration = this.durations[String(idx + 1)] || variant.title;
          items.push({
            role: str.base, isBase: true, id: variant.id, price: variant.price, image: variant.image, url: base.url,
            name: (str.baseName || '[produit]').replace('[produit]', base.title).replace('[durée]', duration),
            why: str.baseWhy, available: variant.available, duration: duration
          });
        }
        (routine.addons || []).forEach(function (a) {
          items.push({ role: str.addon, isBase: false, id: a.id, price: a.price, image: a.image, url: a.url, name: a.title, why: a.why, available: a.available });
        });

        this.querySelector('[data-r-title]').textContent = routine.title || '';
        this.querySelector('[data-r-desc]').textContent = routine.desc || '';

        var recap = this.querySelector('[data-r-recap]');
        recap.innerHTML = '';
        var answers = this.answers;
        this.steps.forEach(function (s, i) {
          recap.appendChild(el('span', 'tpb-quiz__pill', answers[i] && answers[i].label ? answers[i].label : (str.empty || '—')));
        });

        var visual = this.querySelector('[data-r-visual]');
        visual.innerHTML = '';
        visual.hidden = !routine.image;
        if (routine.image) {
          var vimg = el('img');
          vimg.src = routine.image;
          vimg.alt = routine.imageAlt || '';
          vimg.loading = 'lazy';
          visual.appendChild(vimg);
        }

        var list = this.querySelector('[data-r-items]');
        list.innerHTML = '';
        var total = 0;
        var cartItems = [];
        items.forEach(function (it) {
          total += Number(it.price) || 0;
          if (it.available !== false) cartItems.push({ id: it.id, quantity: 1 });
          var row = el('div', 'tpb-quiz__item');
          var media = el('a', 'tpb-quiz__item-img');
          media.href = it.url || '#';
          media.setAttribute('aria-hidden', 'true');
          media.tabIndex = -1;
          if (it.image) {
            var img = el('img');
            img.src = it.image;
            img.alt = '';
            img.width = 64;
            img.height = 64;
            img.loading = 'lazy';
            media.appendChild(img);
          }
          var info = el('div', 'tpb-quiz__item-info');
          info.appendChild(el('div', 'tpb-quiz__role' + (it.isBase ? ' tpb-quiz__role--base' : ''), it.role || ''));
          var name = el('a', 'tpb-quiz__item-name', it.name);
          name.href = it.url || '#';
          info.appendChild(name);
          if (it.why) info.appendChild(el('p', 'tpb-quiz__item-why', it.why));
          row.appendChild(media);
          row.appendChild(info);
          row.appendChild(el('div', 'tpb-quiz__item-price', money(it.price)));
          list.appendChild(row);
        });

        var baseItem = items[0] && items[0].isBase ? items[0] : null;
        this.querySelector('[data-r-duration]').textContent = baseItem ? (str.duration || '').replace('[durée]', baseItem.duration) : '';
        this.querySelector('[data-r-total]').textContent = money(total);
        var add = this.querySelector('[data-r-add]');
        add.textContent = (str.add || '[total]').replace('[total]', money(total));
        add.setAttribute('data-items', JSON.stringify(cartItems));
        add.disabled = cartItems.length === 0;
      }
    }

    customElements.define('tpb-quiz', TpbQuiz);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpb-results"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function revealResult(event) {
      var card = event.target;
      if (!card || !card.classList || !card.classList.contains('tpb-results__card')) return;
      var slider = card.closest('tpb-slider');
      if (card.hidden && slider) {
        var all = slider.querySelector('[data-filter="all"]') || slider.querySelector('[data-filter]');
        if (all) all.click();
      }
      var track = card.parentElement;
      if (track) track.scrollBy({ left: card.getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: 'smooth' });
    }
    document.addEventListener('shopify:block:select', revealResult);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpb-routine-finder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('tpb-routine-finder')) return;
    class TpbRoutineFinder extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.addEventListener('click', function (e) {
          var tab = e.target.closest('[data-routine-tab]');
          if (tab && self.contains(tab)) self.select(tab.getAttribute('data-routine-tab'));
        });
        this.addEventListener('keydown', function (e) {
          var tab = e.target.closest('[data-routine-tab]');
          if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
          var tabs = Array.prototype.slice.call(self.querySelectorAll('[data-routine-tab]'));
          var i = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
          var next = tabs[(i + tabs.length) % tabs.length];
          next.focus();
          self.select(next.getAttribute('data-routine-tab'));
        });
      }
      select(id) {
        this.querySelectorAll('[data-routine-tab]').forEach(function (t) {
          var on = t.getAttribute('data-routine-tab') === id;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        this.querySelectorAll('[data-routine-panel]').forEach(function (p) {
          p.hidden = p.getAttribute('data-routine-panel') !== id;
        });
      }
    }
    customElements.define('tpb-routine-finder', TpbRoutineFinder);

    document.addEventListener('shopify:block:select', function (e) {
      var panel = e.target.closest && e.target.closest('[data-routine-panel]');
      if (!panel) return;
      var finder = panel.closest('tpb-routine-finder');
      if (finder && finder.select) finder.select(panel.getAttribute('data-routine-panel'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpb-store-locator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('tpb-store-locator')) return;

    var leafletPromise = null;
    function loadLeaflet(src) {
      if (window.L) return Promise.resolve(window.L);
      if (leafletPromise) return leafletPromise;
      leafletPromise = new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.crossOrigin = '';
        script.onload = function () { resolve(window.L); };
        script.onerror = function () { leafletPromise = null; reject(new Error('Leaflet')); };
        document.head.appendChild(script);
      });
      return leafletPromise;
    }

    var PIN = '<svg viewBox="0 0 30 38" width="30" height="38" aria-hidden="true"><path d="M15 1.5c-6.6 0-12 5.3-12 11.9C3 22.6 15 36.5 15 36.5S27 22.6 27 13.4C27 6.8 21.6 1.5 15 1.5Z" style="fill: var(--tpb-primary, #121212)"/><path d="M15 9v8M11 13h8" style="stroke: var(--tpb-page, #FFFDFB)" stroke-width="2.2" stroke-linecap="round"/></svg>';

    function num(v) {
      var n = parseFloat(String(v || '').replace(',', '.'));
      return isNaN(n) ? null : n;
    }

    class TpbStoreLocator extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.items = Array.prototype.slice.call(this.querySelectorAll('[data-sl-item]'));
        this.empty = this.querySelector('[data-sl-empty]');
        this.search = this.querySelector('[data-sl-search]');
        this.mapEl = this.querySelector('[data-sl-map]');
        this.markers = [];

        this.items.forEach(function (item) {
          item.addEventListener('click', function () { self.select(item, true); });
        });
        if (this.search) {
          this.search.addEventListener('input', function () { self.filter(self.search.value); });
        }
        this._onBlockSelect = function (e) {
          var item = e.target.closest && e.target.closest('[data-sl-item]');
          if (item && self.contains(item)) self.select(item, true);
        };
        document.addEventListener('shopify:block:select', this._onBlockSelect);

        loadLeaflet(this.getAttribute('data-leaflet-js'))
          .then(function () { self.initMap(); })
          .catch(function () {});
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this._onBlockSelect);
        if (this._ro) this._ro.disconnect();
        if (this.map) { this.map.remove(); this.map = null; }
      }

      initMap() {
        if (this.map || !window.L || !this.mapEl || !this.isConnected) return;
        var L = window.L;
        var self = this;
        var lat = num(this.getAttribute('data-lat'));
        var lng = num(this.getAttribute('data-lng'));
        var zoom = num(this.getAttribute('data-zoom'));
        this.map = L.map(this.mapEl, { scrollWheelZoom: false }).setView([lat == null ? 46.7 : lat, lng == null ? 2.4 : lng], zoom == null ? 5.4 : zoom);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '© OpenStreetMap', maxZoom: 18
        }).addTo(this.map);
        var icon = L.divIcon({ className: 'tpb-pin', html: PIN, iconSize: [30, 38], iconAnchor: [15, 36], popupAnchor: [0, -32] });

        this.items.forEach(function (item) {
          var plat = num(item.getAttribute('data-lat'));
          var plng = num(item.getAttribute('data-lng'));
          if (plat == null || plng == null) return;
          var popup = document.createElement('div');
          var strong = document.createElement('strong');
          strong.textContent = (item.querySelector('[data-sl-name]') || {}).textContent || '';
          var span = document.createElement('span');
          span.textContent = (item.querySelector('[data-sl-address]') || {}).textContent || '';
          popup.appendChild(strong);
          popup.appendChild(document.createElement('br'));
          popup.appendChild(span);
          var marker = L.marker([plat, plng], { icon: icon, title: strong.textContent }).addTo(self.map).bindPopup(popup);
          marker.on('click', function () { self.select(item, false); });
          item._marker = marker;
          self.markers.push(marker);
        });

        setTimeout(function () { if (self.map) self.map.invalidateSize(); }, 120);
        if ('ResizeObserver' in window) {
          this._ro = new ResizeObserver(function () { if (self.map) self.map.invalidateSize(); });
          this._ro.observe(this.mapEl);
        }
      }

      select(item, focusMap) {
        this.items.forEach(function (it) {
          var on = it === item;
          it.classList.toggle('is-active', on);
          it.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (!focusMap) {
          var list = item.parentElement;
          if (list) list.scrollTo({ top: item.offsetTop - list.offsetTop - 8, behavior: 'smooth' });
          return;
        }
        var lat = num(item.getAttribute('data-lat'));
        var lng = num(item.getAttribute('data-lng'));
        if (this.map && lat != null && lng != null) {
          this.map.setView([lat, lng], Number(this.getAttribute('data-focus-zoom')) || 13, { animate: true });
          if (item._marker) item._marker.openPopup();
        }
      }

      filter(query) {
        var q = (query || '').trim().toLowerCase();
        var visible = 0;
        this.items.forEach(function (item) {
          var match = !q || (item.getAttribute('data-search') || '').indexOf(q) >= 0;
          item.hidden = !match;
          if (match) visible++;
        });
        if (this.empty) this.empty.hidden = visible > 0;
      }
    }

    customElements.define('tpb-store-locator', TpbStoreLocator);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpb-video-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('tpb-video-card')) return;

    class TpbVideoCard extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-video-play]');
        if (!this.button || this._bound) return;
        this._bound = true;
        this.button.addEventListener('click', this.play.bind(this));
      }

      play() {
        var template = this.querySelector('template');
        var media = this.querySelector('[data-video-media]');
        if (!template || !media) return;
        var video = media.querySelector('video');
        if (!video) {
          media.appendChild(template.content.cloneNode(true));
          video = media.querySelector('video');
          if (!video) return;
          video.addEventListener('play', function () {
            document.querySelectorAll('tpb-video-card video').forEach(function (v) {
              if (v !== video) v.pause();
            });
          });
        }
        var self = this;
        document.querySelectorAll('tpb-video-card.is-playing').forEach(function (card) {
          if (card === self) return;
          var other = card.querySelector('video');
          if (other) other.pause();
        });
        this.classList.add('is-playing');
        var promise = video.play();
        if (promise && promise.catch) promise.catch(function () {});
        video.focus({ preventScroll: true });
      }
    }

    customElements.define('tpb-video-card', TpbVideoCard);
  })();

  } catch(e) { console.error(e); }
})();
})();
